module.exports = __webpack_public_path__ + "img/cronoc-logo.2872694a.png";